module.exports = __webpack_public_path__ + "media/images/logo2-9b1637160296194851f35e659f93fc73.png";